var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "current-list" },
    [
      _c("div", { staticClass: "height" }, [
        _c("div", { staticClass: "flex-between h32 mt20" }, [
          _c("div", { staticClass: "title-16" }, [_vm._v("绩效考核")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.selectTemplate } },
                [_vm._v(_vm._s(_vm.$t("access.addtarget")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.dimensionMax <= 0,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.addAssess },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("access.adddimension")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-between mt20 mb10" }, [
          _vm.tempButton < 2
            ? _c(
                "div",
                { staticClass: "flex" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "mr10",
                      staticStyle: { width: "160px" },
                      attrs: {
                        disabled: _vm.isEdit && _vm.strType !== "copy",
                        placeholder: "考核类型",
                        size: "small",
                      },
                      on: { change: _vm.changePeriod },
                      model: {
                        value: _vm.tableFrom.period,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "period", $$v)
                        },
                        expression: "tableFrom.period",
                      },
                    },
                    _vm._l(_vm.periodOption, function (item, indx) {
                      return _c("el-option", {
                        key: indx,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.tableFrom.period !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "mr10",
                          staticStyle: { width: "250px" },
                        },
                        [
                          _vm.tableFrom.period === 1 ||
                          _vm.tableFrom.period === 2
                            ? _c("el-date-picker", {
                                ref: "getDateValue",
                                staticStyle: { flex: "1", width: "100%" },
                                attrs: {
                                  format:
                                    _vm.dateArray[_vm.tableFrom.period - 1]
                                      .format,
                                  "value-format": "yyyy-MM",
                                  placeholder:
                                    _vm.dateArray[_vm.tableFrom.period - 1]
                                      .text,
                                  type: _vm.dateArray[_vm.tableFrom.period - 1]
                                    .type,
                                  size: "small",
                                },
                                on: { change: _vm.getDateValue },
                                model: {
                                  value: _vm.tableFrom.time,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.tableFrom, "time", $$v)
                                  },
                                  expression: "tableFrom.time",
                                },
                              })
                            : _vm.tableFrom.period === 3
                            ? _c("el-date-picker", {
                                ref: "getDateValue",
                                attrs: {
                                  format: _vm.dateArray[4].format,
                                  placeholder: _vm.dateArray[4].text,
                                  type: _vm.dateArray[4].type,
                                  size: "small",
                                },
                                on: { change: _vm.getDateValue },
                                model: {
                                  value: _vm.tableFrom.time,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.tableFrom, "time", $$v)
                                  },
                                  expression: "tableFrom.time",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.quarterBtn
                            ? _c("dateQuarter", {
                                ref: "dateQuarter",
                                attrs: {
                                  "get-value": _vm.getQuarterDate,
                                  "half-year-btn": _vm.halfYearBtn,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "160px" },
                      attrs: {
                        disabled: _vm.isEdit && _vm.strType !== "copy",
                        placeholder: _vm.$t("access.selectexaminee"),
                        multiple: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.tableFrom.testUid,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "testUid", $$v)
                        },
                        expression: "tableFrom.testUid",
                      },
                    },
                    _vm._l(_vm.frameUserOption, function (value, key) {
                      return _c("el-option", {
                        key: key,
                        attrs: {
                          label: value.card ? value.card.name : value.name,
                          value: value.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _vm.enterprise.compute_mode === 0
              ? _c("div", { staticClass: "current-button-left text-right" }, [
                  _c("span", [_vm._v("总权重:")]),
                  _c("span", [_vm._v(" 100% ")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pl15" }, [
                    _vm._v(" 当前总权重: "),
                  ]),
                  _c(
                    "span",
                    {
                      class:
                        _vm.handleTotalWeight() !== 100
                          ? "color-danger"
                          : "color-default",
                    },
                    [_vm._v(_vm._s(_vm.handleTotalWeight()))]
                  ),
                  _vm._v("\n          %\n        "),
                ])
              : _c("div", { staticClass: "current-button-left text-right" }, [
                  _c("span", [_vm._v("总分:")]),
                  _c("span", [_vm._v(" " + _vm._s(_vm.enterprise.maxScore))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pl15" }, [_vm._v(" 当前总分: ")]),
                  _c(
                    "span",
                    {
                      class:
                        _vm.handleTotalWeight() !== _vm.enterprise.maxScore
                          ? "color-danger"
                          : "color-default",
                    },
                    [_vm._v(_vm._s(_vm.handleTotalWeight()))]
                  ),
                ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c(
              "el-scrollbar",
              { staticStyle: { height: "100%" } },
              _vm._l(_vm.tableData, function (itm, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "current-table" },
                  [
                    _c("div", { staticClass: "current-table-title" }, [
                      _c("p", [
                        _c("span", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: itm.name,
                                expression: "itm.name",
                              },
                            ],
                            staticClass: "current-title-input",
                            style: { width: _vm.text(itm.name) },
                            attrs: { autofocus: true, type: "text" },
                            domProps: { value: itm.name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(itm, "name", $event.target.value)
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.enterprise.compute_mode
                                      ? _vm.$t("access.dimensionscore")
                                      : _vm.$t("access.dimensionweight")
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-input-number", {
                              attrs: {
                                controls: false,
                                max: itm.weight,
                                min: 0,
                              },
                              model: {
                                value: itm.ratio,
                                callback: function ($$v) {
                                  _vm.$set(itm, "ratio", $$v)
                                },
                                expression: "itm.ratio",
                              },
                            }),
                            _vm._v(" "),
                            !_vm.enterprise.compute_mode
                              ? _c("span", [_vm._v("%")])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.enterprise.compute_mode
                          ? _c("span", [
                              _c("span", [_vm._v(" 当前权重 ")]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  class:
                                    _vm.handleWeight(itm.target) !== 100
                                      ? "color-danger"
                                      : "color-default",
                                },
                                [_vm._v(_vm._s(_vm.handleWeight(itm.target)))]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("%")]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-right" }, [
                        _c("i", {
                          staticClass: "el-icon-edit",
                          on: {
                            click: function ($event) {
                              return _vm.editRatioName(index)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-delete ml6",
                          on: {
                            click: function ($event) {
                              return _vm.deleteTargetList(index)
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: itm.target,
                          "default-expand-all": "",
                          "row-key": "id",
                        },
                      },
                      [
                        _c(
                          "el-table-column",
                          {
                            attrs: { "min-width": "160", prop: "name" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.strType !== "check"
                                        ? _c("el-input", {
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "access.placeholder01"
                                              ),
                                              autosize: "",
                                              type: "textarea",
                                            },
                                            model: {
                                              value: scope.row.name,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "name", $$v)
                                              },
                                              expression: "scope.row.name",
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(scope.row.name)),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(" 指标名称 "),
                              _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: { "min-width": "330", prop: "content" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.strType !== "check"
                                        ? _c("el-input", {
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "access.placeholder02"
                                              ),
                                              autosize: "",
                                              maxlength: "255",
                                              type: "textarea",
                                            },
                                            model: {
                                              value: scope.row.content,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "content",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.content",
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(scope.row.content)),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(" 指标说明 "),
                              _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: { "min-width": "330", prop: "info" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.strType !== "check"
                                        ? _c("el-input", {
                                            attrs: {
                                              autosize: "",
                                              maxlength: "255",
                                              placeholder: "输入评分标准",
                                              type: "textarea",
                                            },
                                            model: {
                                              value: scope.row.info,
                                              callback: function ($$v) {
                                                _vm.$set(scope.row, "info", $$v)
                                              },
                                              expression: "scope.row.info",
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(scope.row.info)),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(" 评分标准 "),
                              _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          {
                            attrs: { prop: "weight", width: "180" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm.strType !== "check"
                                        ? _c("el-input-number", {
                                            staticClass: "current-task",
                                            staticStyle: { width: "150px" },
                                            attrs: {
                                              max: 1000,
                                              min: 0,
                                              step: 5,
                                              "controls-position": "right",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleScore(index)
                                              },
                                            },
                                            model: {
                                              value: scope.row.ratio,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "ratio",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.ratio",
                                            },
                                          })
                                        : _c("span", [
                                            _vm._v(_vm._s(scope.row.ratio)),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.enterprise.compute_mode
                                    ? "分数"
                                    : "权重(%)"
                                ) + "\n                "
                              ),
                              _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            ]),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: _vm.$t("public.operation"),
                            fixed: "right",
                            prop: "address",
                            width: "120",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-button", {
                                      staticClass: "current-delete",
                                      attrs: {
                                        icon: "el-icon-delete",
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(
                                            index,
                                            scope.$index
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "current-bottom" },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { lg: 12 } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addTarget(index)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("access.addTarget02")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectTarget(index)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("access.addTarget01")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.strType !== "check"
          ? _c(
              "div",
              { staticClass: "current-footer text-center" },
              [
                _vm.addButton
                  ? _c(
                      "el-button",
                      { attrs: { size: "small" }, on: { click: _vm.addTemp } },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.tempButton === 1 ? "设置模板" : "编辑模板"
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.addButton
                  ? _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.addTemplate },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.tempButton === 1 ? "设置模板" : "编辑模板"
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: _vm.saveLoading,
                      size: "small",
                      type: "primary",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addPreserve()
                      },
                    },
                  },
                  [_vm._v(" 保存 ")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            title: _vm.$t("access.adddimension"),
            visible: _vm.dialogVisible,
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "current-dialog mb15" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("access.dimensionname")) + "："),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small", type: "text" },
                model: {
                  value: _vm.from.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.from, "name", $$v)
                  },
                  expression: "from.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.enterprise.compute_mode
            ? _c("div", { staticClass: "current-dialog" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("access.dimensionweight")) + "："),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        controls: false,
                        max: _vm.editDimension == 1 ? _vm.dimensionMax : 100,
                        min: 1,
                        size: "small",
                      },
                      model: {
                        value: _vm.from.ratio,
                        callback: function ($$v) {
                          _vm.$set(_vm.from, "ratio", $$v)
                        },
                        expression: "from.ratio",
                      },
                    }),
                    _vm._v(" "),
                    !_vm.enterprise.compute_mode
                      ? _c("span", { staticClass: "current-dialog-icon" }, [
                          _vm._v("%"),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.clickCancel } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.addOk },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.templateClose,
            title: _vm.$t("access.settemplate"),
            visible: _vm.dialogTemplate,
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTemplate = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "current-dialog mb15" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("access.templatename")) + "："),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small", type: "text" },
                model: {
                  value: _vm.info.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "name", $$v)
                  },
                  expression: "info.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "current-dialog mb15" },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("access.templatecontent")) + "："),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { size: "small", type: "text" },
                model: {
                  value: _vm.info.info,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "info", $$v)
                  },
                  expression: "info.info",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancelTemplate } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.tempLoading,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.templateOk },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("selectTarget", {
        ref: "selectTarget",
        attrs: { title: _vm.$t("access.targetibrary") },
        on: { dialogChangeDada: _vm.dialogChangeDada },
      }),
      _vm._v(" "),
      _c("selectTemplate", {
        ref: "selectTemplate",
        attrs: {
          "remind-button": _vm.remindButton,
          title: _vm.$t("access.appraisallibrary"),
        },
        on: { templateChange: _vm.templateChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }